module.exports = __webpack_public_path__ + "media/payments/upgrade-month-4f708b04.png";